type AnalyticsTrackingConsentState = {
  requiresAnalyticsTrackingConsent?: boolean | null;
  analyticsTrackingConsentedAt?: string | null;
  allowUnauthenticatedAnalyticsTracking?: boolean | null;
  clubDefaultCountryCode?: string | null;
  hasAuthenticatedUser?: boolean;
};

let analyticsTrackingAllowed = false;

export const setAnalyticsTrackingAllowed = (allowed: boolean) => {
  analyticsTrackingAllowed = allowed;
};

export const isAnalyticsTrackingAllowed = () => analyticsTrackingAllowed;

export const shouldAllowAnalyticsTracking = ({
  requiresAnalyticsTrackingConsent,
  analyticsTrackingConsentedAt,
  allowUnauthenticatedAnalyticsTracking,
  clubDefaultCountryCode,
  hasAuthenticatedUser = true,
}: AnalyticsTrackingConsentState) => {
  if (!hasAuthenticatedUser) {
    return (
      !!allowUnauthenticatedAnalyticsTracking &&
      !isNonUsCountryCode(clubDefaultCountryCode)
    );
  }

  if (
    requiresAnalyticsTrackingConsent ||
    isNonUsCountryCode(clubDefaultCountryCode)
  ) {
    return !!analyticsTrackingConsentedAt;
  }

  return true;
};

const isNonUsCountryCode = (countryCode?: string | null) => {
  return !!countryCode && countryCode.trim().toUpperCase() !== "US";
};
